
const globalConfig = {};

// config.RealData = true;	// true: call api, false: mockup data

// config.APIHost = 'http://192.168.43.63:8000';   // localhost mobile hotspot



// config.APIHost = 'https://mvis-dp.as.r.appspot.com';   // GAE: MVIS-DP (PROD)




// config.APIHost = 'http://192.168.1.63:8000';   // localhost home
// config.APIHost = 'https://mvis-api.isurvey.mobi';   // GAE: MVIS-DP (PROD) - via domain


// config.APIHost = 'http://10.50.51.101:8000';   // localhost office
// config.APIHost = 'https://api-uat-dot-mvis-dp.as.r.appspot.com';   // GAE: MVIS-DP (UAT)



// globalConfig.APIHost = 'http://10.50.51.209:8000';   // localhost office
globalConfig.APIHost = 'https://api-ext.isurvey.mobi';	// PROD




export default globalConfig;